import dayjs from 'dayjs'

export const getTimeFromDate = (value: string | null) => {
  if (!value) {
    return ''
  }
  const hour = dayjs(value).get('h')
  const minutes = dayjs(value).get('m')
  const formedHour = hour < 10 ? `0${hour}` : hour
  const formedMinutes = minutes < 10 ? `0${minutes}` : minutes
  return `${formedHour}:${formedMinutes}`
}
